module.exports = __webpack_public_path__ + "media/images/icon_address02_40-40-e39e4b7c713596ddbc63e63b1f24204a.png";